/* jshint esnext: true */
import Form from './Form';

import { unescapeHtml } from '../utils/html';

export default class extends Form {
    constructor (options) {
        super(options);
        this.isOwnerExecutant = false;
        this.controller = this.initController();
    }

    initController() {
        var _this = this;
        var controller = new Ractive({
            el: this.$el,
            template: unescapeHtml(this.$el.html()),
            data: {
                name: '',
                address: '',
                postalCode: '',
                telephone: '',
                cellphone: '',
                locationType: '',
                locationIdentLabel: 'N˚ de cadastre',
                executant_name: '',
                executant_address: '',
                executant_postalCode: '',
                executant_telephone: '',
                executant_cellphone: '',
                executantType: '',
                reqDisabled: false
            },
            computed: {
            },
            /**
             * Allows us to set proxy events and run other tasks when controller is initialized
             * @param  {array}  options  Array of options
             */
            oninit: function(options) {
                this.on({
                });
            }
        });

        controller.observe('executantType', (newValue) => {
            if (newValue === 'Propriétaire') {
                this.isOwnerExecutant = true;
                controller.set({
                    req: '',
                    reqDisabled: true,
                    executant_name: controller.get('name'),
                    executant_address: controller.get('address'),
                    executant_postalCode: controller.get('postalCode'),
                    executant_telephone: controller.get('telephone'),
                    executant_cellphone: controller.get('cellphone')
                })
            } else {
                this.isOwnerExecutant = false;
                controller.set({
                    reqDisabled: false,
                    executant_name: '',
                    executant_address: '',
                    executant_postalCode: '',
                    executant_telephone: '',
                    executant_cellphone: ''
                })
            }
        });

        controller.observe('name address postalCode telephone cellphone', (newValue, oldValue, keypath) => {
            if (this.isOwnerExecutant === true) {
                controller.set('executant_' + keypath, newValue);
            }
        });

        controller.observe('locationType', (newValue) => {
            controller.set('locationIdentLabel', (newValue !== 'Bâtiments') ? 'N˚ de cadastre' : 'Adresse');
        });

        // Store them jQuery elems
        _this.setElements();

        return controller;
    }

    destroy() {
        this.controller.teardown();
        this.$el.off('.PermitForm');
    }
}
